import React from 'react'
import PropTypes from 'prop-types'
import * as styles from './styles'

const propTypes = {
  iconSrc: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired
}

const DataSource = (props) => {
  const { iconSrc, text } = props
  return (
    <styles.Container>
      <styles.DataSourceIcon src={iconSrc} alt="" />
      <styles.DataSourceText>{text}</styles.DataSourceText>
    </styles.Container>
  )
}

DataSource.propTypes = propTypes

export default DataSource
